// 首页展示配置模块API接口

import { BaseApi } from "../../../utils/request";
import { HomeDisplayConfig } from "../types";

/**
 * 协议内容接口
 */
export interface ProtocolContent {
  id: string;
  name: string;
  content: string;
  enabled: boolean;
  path: string;
  countryId: string;
}

/**
 * 首页展示配置API类
 */
export class HomeDisplayApi extends BaseApi {
  /**
   * 获取首页展示配置
   * @description 获取Banner配置、弹窗时机配置、弹窗优先级配置
   * @returns Promise<HomeDisplayConfig>
   */
  async getConfig(): Promise<HomeDisplayConfig> {
    const response = await this.get<HomeDisplayConfig, true>(
      "/api/home_display/config",
      {},
      {
        cache: true,
        cacheTime: 5 * 60 * 1000, // 5分钟缓存
        alert: false,
      }
    );
    return response.data.model;
  }

  /**
   * 获取协议内容
   * @param path 协议路径，如 /protocol/terms
   * @returns Promise<ProtocolContent>
   */
  async getProtocol(path: string): Promise<ProtocolContent> {
    const response = await this.post<ProtocolContent, true>(
      "/api/home_display/protocol",
      { path },
      { alert: false }
    );
    return (response.data as { model: ProtocolContent }).model;
  }
}

// 创建API实例
export const homeDisplayApi = new HomeDisplayApi();
